import React, { useState, useEffect, useRef } from "react";

import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { toast } from "react-toastify";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Tooltip from "@material-ui/core/Tooltip";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Divider from "@material-ui/core/Divider";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import RemoveIcon from "@material-ui/icons/Remove";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";

import { i18n } from "../../translate/i18n";
import { head } from "lodash";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import ConfirmationModal from "../ConfirmationModal";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  multFieldLine: {
    display: "flex",
    "& > *:not(:last-child)": {
      marginRight: theme.spacing(1),
    },
  },
  btnWrapper: {
    position: "relative",
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  colorAdorment: {
    width: 20,
    height: 20,
  },
  dialogTitle: {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: 'white',
    padding: '20px 24px',
    display: 'flex',
    alignItems: 'center',
    gap: 12
  },
  formSection: {
    marginBottom: theme.spacing(3),
  },
  sectionTitle: {
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    gap: 8
  },
  // ✅ CORREGIDO: TextField dinámico según tema
  textField: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
      color: theme.palette.text.primary,
      '&:hover': {
        backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#eeeeee',
      },
      '&.Mui-focused': {
        backgroundColor: theme.mode === 'dark' ? '#374151' : 'white',
        boxShadow: `0 0 0 2px ${theme.mode === 'dark' ? 'rgba(59, 130, 246, 0.3)' : 'rgba(25, 118, 210, 0.2)'}`,
      },
      "& fieldset": {
        borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: theme.palette.primary.main,
    },
    "& .MuiFormHelperText-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
  },
  // ✅ CORREGIDO: FormControl dinámico según tema
  formControlDynamic: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
      color: theme.palette.text.primary,
      '&:hover': {
        backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#eeeeee',
      },
      "& fieldset": {
        borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
      "&.Mui-focused": {
        color: theme.palette.primary.main,
      },
    },
    "& .MuiSelect-root": {
      color: theme.palette.text.primary,
    },
    "& .MuiMenuItem-root": {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      "&:hover": {
        backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
      },
    },
  },
  // ✅ CORREGIDO: PriorityCard dinámico según tema
  priorityCard: {
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
    borderRadius: 8,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.mode === 'dark' ? '0 2px 8px rgba(0,0,0,0.3)' : '0 2px 8px rgba(0,0,0,0.08)',
  },
  // ✅ CORREGIDO: StatusCard dinámico según tema
  statusCard: {
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
    borderRadius: 8,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.mode === 'dark' ? '0 2px 8px rgba(0,0,0,0.3)' : '0 2px 8px rgba(0,0,0,0.08)',
  },
  // ✅ CORREGIDO: AttachmentCard dinámico según tema
  attachmentCard: {
    border: `2px dashed ${theme.mode === 'dark' ? '#6B7280' : '#ccc'}`,
    borderRadius: 8,
    padding: theme.spacing(2),
    textAlign: 'center',
    backgroundColor: theme.mode === 'dark' ? '#374151' : '#f9f9f9',
    marginBottom: theme.spacing(2),
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    '&:hover': {
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.mode === 'dark' ? '#4B5563' : theme.palette.primary.light + '10',
    }
  },
  attachmentButton: {
    borderRadius: 8,
    textTransform: 'none',
    fontWeight: 600,
    marginTop: theme.spacing(1),
  },
  actionButtons: {
    display: 'flex',
    gap: theme.spacing(2),
    justifyContent: 'flex-end',
  },
  saveButton: {
    borderRadius: 8,
    textTransform: 'none',
    fontWeight: 600,
    minWidth: 120,
  },
  cancelButton: {
    borderRadius: 8,
    textTransform: 'none',
    fontWeight: 600,
    minWidth: 120,
  },
  helperText: {
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(1),
    fontStyle: 'italic',
  },
}));

const AnnouncementSchema = Yup.object().shape({
  title: Yup.string()
    .required("El título es obligatorio")
    .test('not-empty', 'El título es obligatorio', function(value) {
      // ✅ Validar que el valor existe y no es solo espacios en blanco
      if (!value) return false;
      return value.trim().length > 0;
    }),
  text: Yup.string()
    .required("El texto es obligatorio")
    .test('not-empty', 'El texto es obligatorio', function(value) {
      // ✅ Validar que el valor existe y no es solo espacios en blanco
      if (!value) return false;
      return value.trim().length > 0;
    }),
});

// Funciones auxiliares para iconos y colores de prioridad y estado
// eslint-disable-next-line no-unused-vars
const getPriorityIcon = (val) => {
  if (val === 1) {
    return <KeyboardArrowUpIcon style={{ color: '#f44336' }} />;
  }
  if (val === 2) {
    return <RemoveIcon style={{ color: '#ff9800' }} />;
  }
  if (val === 3) {
    return <KeyboardArrowDownIcon style={{ color: '#4caf50' }} />;
  }
};

// eslint-disable-next-line no-unused-vars
const getPriorityColor = (val) => {
  if (val === 1) {
    return '#f44336';
  }
  if (val === 2) {
    return '#ff9800';
  }
  if (val === 3) {
    return '#4caf50';
  }
};

// eslint-disable-next-line no-unused-vars
const getPriorityText = (val) => {
  if (val === 1) {
    return "Alta";
  }
  if (val === 2) {
    return "Media";
  }
  if (val === 3) {
    return "Baja";
  }
};

// eslint-disable-next-line no-unused-vars
const getStatusIcon = (status) => {
  return status ? 
    <CheckCircleIcon style={{ color: '#4caf50' }} /> : 
    <CancelIcon style={{ color: '#f44336' }} />;
};

// eslint-disable-next-line no-unused-vars
const getStatusText = (status) => {
  return status ? 'Activo' : 'Inactivo';
};

const AnnouncementModal = ({ open, onClose, announcementId, reload }) => {
  const classes = useStyles();
  const theme = useTheme();

  const initialState = {
    title: "",
    text: "",
    priority: 3,
    status: true,
  };

  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [announcement, setAnnouncement] = useState(initialState);
  const [attachment, setAttachment] = useState(null);
  const attachmentFile = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    try {
      (async () => {
        if (!announcementId) {
          // ✅ Si no hay ID, resetear a valores iniciales
          setAnnouncement(initialState);
          setIsLoading(false);
          return;
        }

        // ✅ Cargar datos del anuncio para editar
        setIsLoading(true);
        const { data } = await api.get(`/announcements/${announcementId}`);
        // ✅ Asegurar que todos los campos estén presentes con valores por defecto si faltan
        setAnnouncement({
          title: data.title || '',
          text: data.text || '',
          priority: data.priority !== undefined ? data.priority : 3,
          status: data.status !== undefined ? data.status : true,
          mediaPath: data.mediaPath || null,
          mediaName: data.mediaName || null,
        });
        setIsLoading(false);
      })();
    } catch (err) {
      toastError(err);
      setIsLoading(false);
    }
  }, [announcementId, open]);

  const handleClose = () => {
    setAnnouncement(initialState);
    setAttachment(null);
    onClose();
  };

  const handleAttachmentFile = (e) => {
    const file = head(e.target.files);
    if (file) {
      setAttachment(file);
    }
  };

  const handleSaveAnnouncement = async (values) => {
    const announcementData = { ...values };
    try {
      if (announcementId) {
        await api.put(`/announcements/${announcementId}`, announcementData);
        if (attachment != null) {
          const formData = new FormData();
          formData.append("file", attachment);
          await api.post(
            `/announcements/${announcementId}/media-upload`,
            formData
          );
        }
      } else {
        const { data } = await api.post("/announcements", announcementData);
        if (attachment != null) {
          const formData = new FormData();
          formData.append("file", attachment);
          await api.post(`/announcements/${data.id}/media-upload`, formData);
        }
      }
      toast.success(i18n.t("announcements.toasts.success"));
      if (typeof reload == "function") {
        reload();
      }
    } catch (err) {
      toastError(err);
    }
    handleClose();
  };

  const deleteMedia = async () => {
    if (attachment) {
      setAttachment(null);
      attachmentFile.current.value = null;
    }

    if (announcement.mediaPath) {
      await api.delete(`/announcements/${announcement.id}/media-upload`);
      setAnnouncement((prev) => ({
        ...prev,
        mediaPath: null,
      }));
      toast.success(i18n.t("announcements.toasts.deleted"));
      if (typeof reload == "function") {
        reload();
      }
    }
  };

  return (
    <div className={classes.root}>
      <ConfirmationModal
        title={i18n.t("announcements.confirmationModal.deleteTitle")}
        open={confirmationOpen}
        onClose={() => setConfirmationOpen(false)}
        onConfirm={deleteMedia}
      >
        {i18n.t("announcements.confirmationModal.deleteMessage")}
      </ConfirmationModal>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        scroll="paper"
        PaperProps={{
          style: {
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
          },
        }}
      >
        <DialogTitle id="form-dialog-title" className={classes.dialogTitle}>
          <span style={{ fontSize: '24px' }} role="img" aria-label="announcement">📢</span>
          <span style={{ fontWeight: 'bold', color: 'white', fontSize: '1.25rem' }}>
            {announcementId
              ? "Editar Anuncio"
              : "Nuevo Anuncio"}
          </span>
        </DialogTitle>
        <div style={{ display: "none" }}>
          <input
            type="file"
            accept=".png,.jpg,.jpeg"
            ref={attachmentFile}
            onChange={(e) => handleAttachmentFile(e)}
          />
        </div>
        <Formik
          key={announcementId || 'new'}
          initialValues={announcement}
          enableReinitialize={true}
          validateOnChange={false}
          validateOnBlur={false}
          validateOnMount={false}
          onSubmit={(values, actions) => {
            // ✅ Validar que los campos no estén vacíos después de trim
            const trimmedTitle = (values.title || '').trim();
            const trimmedText = (values.text || '').trim();
            
            // ✅ Validar AMBOS campos y establecer errores para ambos si es necesario
            let hasErrors = false;
            
            if (!trimmedTitle || trimmedTitle.length === 0) {
              actions.setFieldTouched('title', true);
              actions.setFieldError('title', 'El título es obligatorio');
              hasErrors = true;
            }
            
            if (!trimmedText || trimmedText.length === 0) {
              actions.setFieldTouched('text', true);
              actions.setFieldError('text', 'El texto es obligatorio');
              hasErrors = true;
            }
            
            // ✅ Si hay errores, no continuar
            if (hasErrors) {
              actions.setSubmitting(false);
              return;
            }
            
            // ✅ Si todo está bien, enviar con valores trimados
            const trimmedValues = {
              ...values,
              title: trimmedTitle,
              text: trimmedText,
            };
            
            setTimeout(() => {
              handleSaveAnnouncement(trimmedValues);
              actions.setSubmitting(false);
            }, 400);
          }}
        >
          {({ touched, errors, isSubmitting, values, setFieldError }) => {
            // ✅ Limpiar errores cuando hay contenido válido
            useEffect(() => {
              if (values.title && typeof values.title === 'string' && values.title.trim().length > 0 && errors.title) {
                setFieldError('title', undefined);
              }
              if (values.text && typeof values.text === 'string' && values.text.trim().length > 0 && errors.text) {
                setFieldError('text', undefined);
              }
            }, [values.title, values.text, errors.title, errors.text, setFieldError]);
            
            // ✅ Calcular si hay errores para mostrar visualmente
            const titleValue = values.title || '';
            const textValue = values.text || '';
            const titleHasError = touched.title && errors.title && (!titleValue || String(titleValue).trim().length === 0);
            const textHasError = touched.text && errors.text && (!textValue || String(textValue).trim().length === 0);
            
            return (
            <Form>
              <DialogContent dividers style={{ 
                padding: 24,
                backgroundColor: theme.palette.background.paper,
                borderTop: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
                borderBottom: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
              }}>
                {/* SECCIÓN INFORMACIÓN BÁSICA */}
                <Box className={classes.formSection}>
                  <Typography variant="h6" className={classes.sectionTitle}>
                    <span role="img" aria-label="info">ℹ️</span>
                    Información Básica
                  </Typography>
                  
                  <Grid spacing={2} container>
                    <Grid xs={12} item>
                      <Field name="title">
                        {({ field }) => (
                          <TextField
                            {...field}
                            label="Título del Anuncio"
                            error={titleHasError}
                            helperText={titleHasError ? errors.title : ''}
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            placeholder="Ej: Nueva política de la empresa"
                            className={classes.textField}
                          />
                        )}
                      </Field>
                      <Typography className={classes.helperText} style={{ color: theme.palette.text.secondary || theme.palette.text.primary }}>
                        Escribe un título claro y descriptivo para tu anuncio
                      </Typography>
                    </Grid>
                    
                    <Grid xs={12} item>
                      <Field name="text">
                        {({ field }) => (
                          <TextField
                            {...field}
                            label="Contenido del Anuncio"
                            error={textHasError}
                            helperText={textHasError ? errors.text : ''}
                            variant="outlined"
                            margin="dense"
                            multiline={true}
                            rows={6}
                            fullWidth
                            placeholder="Describe aquí el contenido completo del anuncio..."
                            className={classes.textField}
                          />
                        )}
                      </Field>
                      <Typography className={classes.helperText} style={{ color: theme.palette.text.secondary || theme.palette.text.primary }}>
                        Proporciona todos los detalles importantes del anuncio
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>

                <Divider style={{ margin: '16px 0', backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0' }} />

                {/* SECCIÓN CONFIGURACIÓN */}
                <Box className={classes.formSection}>
                  <Typography variant="h6" className={classes.sectionTitle}>
                    <span role="img" aria-label="settings">⚙️</span>
                    Configuración
                  </Typography>
                  
                  <Grid spacing={2} container>
                    <Grid xs={12} sm={6} item>
                      <Card className={classes.priorityCard}>
                        <CardContent style={{ padding: 16, backgroundColor: theme.palette.background.paper }}>
                          <Typography variant="subtitle2" style={{ color: theme.palette.text.primary }} gutterBottom>
                            Prioridad del Anuncio
                          </Typography>
                          <FormControl variant="outlined" fullWidth className={classes.formControlDynamic}>
                            <InputLabel id="priority-selection-label" style={{ color: theme.palette.text.secondary || theme.palette.text.primary }}>
                              Seleccionar Prioridad
                            </InputLabel>
                            <Field
                              as={Select}
                              label="Seleccionar Prioridad"
                              labelId="priority-selection-label"
                              id="priority"
                              name="priority"
                              error={touched.priority && Boolean(errors.priority)}
                            >
                              <MenuItem value={1}>
                                <Box display="flex" alignItems="center" gap={1}>
                                  <KeyboardArrowUpIcon style={{ color: '#f44336' }} />
                                  Alta Prioridad
                                </Box>
                              </MenuItem>
                              <MenuItem value={2}>
                                <Box display="flex" alignItems="center" gap={1}>
                                  <RemoveIcon style={{ color: '#ff9800' }} />
                                  Media Prioridad
                                </Box>
                              </MenuItem>
                              <MenuItem value={3}>
                                <Box display="flex" alignItems="center" gap={1}>
                                  <KeyboardArrowDownIcon style={{ color: '#4caf50' }} />
                                  Baja Prioridad
                                </Box>
                              </MenuItem>
                            </Field>
                          </FormControl>
                          <Typography className={classes.helperText} style={{ color: theme.palette.text.secondary || theme.palette.text.primary }}>
                            Define qué tan importante es este anuncio
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                    
                    <Grid xs={12} sm={6} item>
                      <Card className={classes.statusCard}>
                        <CardContent style={{ padding: 16, backgroundColor: theme.palette.background.paper }}>
                          <Typography variant="subtitle2" style={{ color: theme.palette.text.primary }} gutterBottom>
                            Estado del Anuncio
                          </Typography>
                          <FormControl variant="outlined" fullWidth className={classes.formControlDynamic}>
                            <InputLabel id="status-selection-label" style={{ color: theme.palette.text.secondary || theme.palette.text.primary }}>
                              Seleccionar Estado
                            </InputLabel>
                            <Field
                              as={Select}
                              label="Seleccionar Estado"
                              labelId="status-selection-label"
                              id="status"
                              name="status"
                              error={touched.status && Boolean(errors.status)}
                            >
                              <MenuItem value={true}>
                                <Box display="flex" alignItems="center" gap={1}>
                                  <CheckCircleIcon style={{ color: '#4caf50' }} />
                                  Activo
                                </Box>
                              </MenuItem>
                              <MenuItem value={false}>
                                <Box display="flex" alignItems="center" gap={1}>
                                  <CancelIcon style={{ color: '#f44336' }} />
                                  Inactivo
                                </Box>
                              </MenuItem>
                            </Field>
                          </FormControl>
                          <Typography className={classes.helperText} style={{ color: theme.palette.text.secondary || theme.palette.text.primary }}>
                            Los anuncios inactivos no se mostrarán a los usuarios
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </Box>

                <Divider style={{ margin: '16px 0', backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0' }} />

                {/* SECCIÓN ARCHIVO ADJUNTO */}
                <Box className={classes.formSection}>
                  <Typography variant="h6" className={classes.sectionTitle}>
                    <span role="img" aria-label="attachment">📎</span>
                    Archivo Adjunto (Opcional)
                  </Typography>
                  
                  {(announcement.mediaPath || attachment) ? (
                    <Card style={{ 
                      border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
                      borderRadius: 8,
                      padding: 16,
                      backgroundColor: theme.palette.background.paper,
                    }}>
                      <CardContent style={{ padding: 16, backgroundColor: theme.palette.background.paper }}>
                        <Box display="flex" alignItems="center" justifyContent="space-between">
                          <Box display="flex" alignItems="center" gap={2}>
                            <AttachFileIcon style={{ color: theme.palette.text.secondary || theme.palette.text.primary }} />
                            <Typography variant="body1" style={{ color: theme.palette.text.primary }}>
                              {attachment ? attachment.name : announcement.mediaName}
                            </Typography>
                          </Box>
                          <Tooltip title="Eliminar archivo">
                            <IconButton
                              onClick={() => setConfirmationOpen(true)}
                              color="secondary"
                              size="small"
                            >
                              <DeleteOutlineIcon style={{ color: theme.palette.error.main }} />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </CardContent>
                    </Card>
                  ) : (
                    <Card className={classes.attachmentCard}>
                      <CardContent style={{ padding: 16, backgroundColor: theme.mode === 'dark' ? '#374151' : '#f9f9f9' }}>
                        <AttachFileIcon style={{ fontSize: 48, color: theme.palette.text.secondary || theme.palette.text.primary, marginBottom: 16 }} />
                        <Typography variant="body1" style={{ color: theme.palette.text.primary }} gutterBottom>
                          Adjuntar Archivo
                        </Typography>
                        <Typography variant="body2" style={{ color: theme.palette.text.secondary || theme.palette.text.primary }} paragraph>
                          Puedes adjuntar una imagen (PNG, JPG, JPEG) para complementar tu anuncio
                        </Typography>
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={() => attachmentFile.current.click()}
                          disabled={isSubmitting}
                          className={classes.attachmentButton}
                          startIcon={<AttachFileIcon />}
                        >
                          Seleccionar Archivo
                        </Button>
                        <Typography className={classes.helperText} style={{ color: theme.palette.text.secondary || theme.palette.text.primary }}>
                          Formatos permitidos: PNG, JPG, JPEG
                        </Typography>
                      </CardContent>
                    </Card>
                  )}
                </Box>
              </DialogContent>
              <DialogActions style={{ 
                padding: '16px 24px',
                backgroundColor: theme.palette.background.paper,
                borderTop: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
              }}>
                <Box className={classes.actionButtons}>
                  <Button
                    onClick={handleClose}
                    color="secondary"
                    disabled={isSubmitting}
                    variant="outlined"
                    className={classes.cancelButton}
                    style={{ color: theme.palette.error.main }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    type="submit"
                    color="primary"
                    disabled={isSubmitting}
                    variant="contained"
                    className={`${classes.saveButton} ${classes.btnWrapper}`}
                  >
                    {isSubmitting ? (
                      <>
                        Guardando...
                        <CircularProgress
                          size={20}
                          className={classes.buttonProgress}
                        />
                      </>
                    ) : (
                      announcementId ? "Actualizar Anuncio" : "Crear Anuncio"
                    )}
                  </Button>
                </Box>
              </DialogActions>
            </Form>
            );
          }}
        </Formik>
      </Dialog>
    </div>
  );
};

export default AnnouncementModal;
